import cfdBasisCharacteristicReport from "./cfdBasisCharacteristicReport";
import cfdDelinquencyReport from "./cfdDelinquencyReport";
import cfdLevyParcelLineItemsReport from "./cfdLevyParcelLineItemsReport";
import cfdLevyReport from "./cfdLevyReport";
import cfdLevySummaryReport from "./cfdLevySummaryReport";
import cfdParcelDetailsReport from "./cfdParcelDetailsReport";

const cfdReports = {
  cfdBasisCharacteristicReport,
  cfdDelinquencyReport,
  cfdLevyParcelLineItemsReport,
  cfdLevyReport,
  cfdLevySummaryReport,
  cfdParcelDetailsReport,
};

export default cfdReports;
